import { useState } from "react";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

// Confirm dialog for destructive actions. onConfirm may be async; errors are shown inline.
export default function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, children, testId = "confirm-dialog", destructive = true, confirmDisabled = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!busy) { setError(null); onOpenChange(o); } }}>
      <AlertDialogContent className="rounded-[20px]" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="cw-soft leading-6">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        {children}
        {error && <p className="cw-error text-sm" role="alert" data-testid={`${testId}-error`}>{error}</p>}
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel disabled={busy} data-testid={`${testId}-cancel-button`}>Cancel</AlertDialogCancel>
          <Button variant={destructive ? "destructive" : "default"} onClick={run} disabled={busy || confirmDisabled} data-testid={`${testId}-confirm-button`}>
            {busy ? "Working…" : confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
